export default "__VITE_ASSET__Pv8WiocM__"